import { CategoryTypeActions } from "./category-type.actions";
import { categoryTypeAdapter } from "./category-type.state";
import { initialCategoryTypeState } from "./category-type.state";
import { createReducer, on } from "@ngrx/store";

export const categoryTypeReducer = createReducer(
    initialCategoryTypeState,
    on(CategoryTypeActions.loadCategoryTypesSuccess, (state, action) => {
        return categoryTypeAdapter.setAll(action.categoryTypes, {
            ...state,
            errorMessage: null
        });
        }),
        on(CategoryTypeActions.addCategoryTypeSuccess, (state, { categoryType }) => {
        if (!categoryType.categoryTypeId) {
            return {
            ...state,
            errorMessage: "categoryTypeId is required"
            };
        }

        const categoryTypeId = String(categoryType.categoryTypeId);
        let updatedEntities = { ...state.entities };
        let updatedIds = [...(state.ids as string[])];

        if (categoryType.parentCategoryTypeId) {
            // Add to parent's children array
            const parentId = String(categoryType.parentCategoryTypeId);
            const parent = updatedEntities[parentId];
            if (parent) {
            updatedEntities[parentId] = {
                ...parent,
                children: [...(parent.children || []), categoryType]
            };
            }
        } else {
            // No parent, push the item in the array (add to root)
            updatedEntities[categoryTypeId] = categoryType;
            if (!updatedIds.includes(categoryTypeId)) {
            updatedIds.push(categoryTypeId);
            }
        }

        return {
            ...state,
            ids: updatedIds,
            entities: updatedEntities,
            errorMessage: null
        };
        }),
        on(CategoryTypeActions.updateCategoryTypeSuccess, (state, { categoryType }) => {
        if (!categoryType.categoryTypeId) {
            return {
                ...state,
                errorMessage: "CategoryTypeId is required for update"
            };
        }
        return categoryTypeAdapter.updateOne({ id: categoryType.categoryTypeId, changes: categoryType }, {
            ...state,
            errorMessage: null
        });
    }),
    on(CategoryTypeActions.deleteCategoryType, (state, { categoryTypeId }) => {
        return categoryTypeAdapter.removeOne(categoryTypeId, {
            ...state,
            errorMessage: null
        });
    }),
);